import axios from "axios";
import Config from "../../config/config";

const listaProdutosExclusivos = data => {
    return axios({
        method: "post",
        url: "https://api.katuxa.com.br/api/v1/apps/pdv/produtos/buscar-produtos-exclusivos",
        data
    });
};

export default listaProdutosExclusivos;
